import { render, staticRenderFns } from "./durations.vue?vue&type=template&id=1f4908bc&"
import script from "./durations.vue?vue&type=script&lang=js&"
export * from "./durations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports